import { Component } from '@theme/component';
import { SlideshowSelectEvent } from '@theme/events';

/**
 * Keeps page-based pagination in sync with Horizon's native slideshow.
 * Horizon remains responsible for scrolling, dragging, snapping, and slide selection.
 */
class EqModernGridPagination extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener(SlideshowSelectEvent.eventName, this.#handleSlideshowSelect);
    this.#syncPagination(0);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.removeEventListener(SlideshowSelectEvent.eventName, this.#handleSlideshowSelect);
  }

  #handleSlideshowSelect = (event) => {
    const index = event.detail?.index;
    if (!Number.isInteger(index)) return;

    this.#syncPagination(index);
  };

  /**
   * @param {number} slideIndex
   */
  #syncPagination(slideIndex) {
    this.#syncDots(this.refs.desktopDots, slideIndex);
    this.#syncDots(this.refs.mobileDots, slideIndex);
  }

  /**
   * @param {HTMLElement[] | undefined} dots
   * @param {number} slideIndex
   */
  #syncDots(dots, slideIndex) {
    if (!Array.isArray(dots) || dots.length === 0) return;

    let activePageIndex = 0;

    dots.forEach((dot, index) => {
      const targetIndex = Number(dot.dataset.targetIndex);

      if (Number.isFinite(targetIndex) && slideIndex >= targetIndex) {
        activePageIndex = index;
      }
    });

    dots.forEach((dot, index) => {
      if (index === activePageIndex) {
        dot.setAttribute('aria-current', 'page');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('eq-modern-grid-pagination')) {
  customElements.define('eq-modern-grid-pagination', EqModernGridPagination);
}
